import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PhoneMaskDirective, MaskEmailCtnPipe, RestrictInputDirective } from './index';

@NgModule({ declarations: [MaskEmailCtnPipe, RestrictInputDirective, PhoneMaskDirective],
    exports: [MaskEmailCtnPipe, RestrictInputDirective, PhoneMaskDirective], imports: [CommonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class CfetCoreModule {
}
